import React from 'react'
import { connect } from 'react-redux'
import { getAppContent } from '../redux/selectors'
import { setAppContentLanguage } from '../redux/actions'


export const LanguageContext = React.createContext()

const LanguageProvider = ({ children, texts }) => {

    const updateDocumentTitle = (title, organizationName) => {
        document.title = `${title} | ${organizationName}`;
    };
    updateDocumentTitle(texts?.title, texts?.client_organization_name)

  return (
    <LanguageContext.Provider
      value={{
        texts,
      }}
    >
      {children}
    </LanguageContext.Provider>
  )
}



const mapStateToProps = (state) => {
  return {
    texts: getAppContent(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return { 
    setReduxLanguage: (language) => dispatch(setAppContentLanguage(language)) 
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LanguageProvider)